import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { IdGeneratorPipe } from '../../pipes/id-generator.pipe';
import { Context, Orientation } from '../../types/separator-line.type';

@Component({
    selector: 'lib-separator-line',
    templateUrl: './separator-line.component.html',
    styleUrls: ['./separator-line.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, IdGeneratorPipe]
})
export class SeparatorLineComponent {
    @Input()
    orientation?: Orientation;

    @Input()
    context?: Context;

    @Input()
    separatorLineId?: string;

    constructor() {
        this.context = 'default';
        this.orientation = 'vertical';
    }
}
